angular.module('iqxCore')
.controller('CandidateCtrl', function ($scope, $location, $routeParams, FormSvc, QuestionnaireSvc, $sce, $http, ApplicationSvc) {
  $scope.userCanEdit=true
  $scope.caneditNI=$scope.userHasRight('CANEDITNI')
  $scope.lang=$scope.params.lang

  if ($scope.userHasRight('CANDHIDEDETAILSPAGE')) {
    $location.url('/noPermission')
  }

  if ($scope.userHasRight('CANDDETAILSREADONLY')) {
    var footer = document.querySelectorAll('form .panel-heading .btn-primary')
    angular.forEach(footer, function(elm, key){
      footer[key].setAttribute('class', 'hide')
    })

    var formElements = document.querySelectorAll('form input')
    angular.forEach(formElements, function(elm, key){
      formElements[key].setAttribute('ng-disabled', 'true')
    })
  }

  FormSvc.setOptions($scope,{
    fetchAPI:'callresult/netcandidateprofile',
    saveAPI:'call/netcandidateprofileset',
    savePrefix:'p',
    saveWithPersonID:false, // is already in the record!
    fetchWithPersonID:true,
    dateFields:['DOB'],
    booleanFields:['OptInToMarketing'],
    primaryKey:'PersonID',
    questionnaire:{
      tagTarget:'tags',
      tagLocation:'P',
      displayGroup:'?CANDIDATE',
      id:ApplicationSvc.currentUser.personID,
      postVar:'qanswers'
      }
    })


  $scope.changepassword=function(){
    $location.path('/changepassword')  // Add departmental registration details
  }

  $scope.doUpdate=function () {  // Over-ride the default update() called by the Save & Submit button
    if ($scope.theRecord.NINumber) {
      $scope.theRecord.NINumber = $scope.theRecord.NINumber.replace(/ /g,'')
    }
    FormSvc.setSubmitted($scope,true)
    return FormSvc.update($scope, false, false)  // Do not do the fetch if submitted
    .then(function(err) { 
      if (!err) {
        FormSvc.alert("Saved", "Your details have been updated.", "success")
      } 
    })
  }
  $scope.update=$scope.doUpdate
  $scope.classes={label:'col-sm-10', data:'col-sm-2'}
  $scope.fetch()

})
